import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {checkCookie} from 'ubs-framework/v2/common/cookie';
import {useSelector} from 'react-redux'

const PublicRoute = ({component: Component, restricted, ...rest}) => {
    const _AFTRP = useSelector(e => e.common.aftrp)

    return (
        // restricted = false meaning public route
        // restricted = true meaning restricted route
        <Route {...rest} render={props => {
            if(props?.location?.search?.includes("redirect_uri") && props?.location?.search?.includes("client_id") && props?.location?.search?.includes("code_challenge")) {
                return (<Redirect to={`/authorize?${props?.location?.search}`}/>)
            } else if (checkCookie('ubs_token') && ["/:orgId/preboarding/register"]?.includes(props?.match?.path) && props?.match?.params?.orgId) {
                /** , Redirect To RECRUIT | Email URL is change from backend after 23-12-2024, every user will Redirect to Register Page, not Login */
                window.location.href = `${process.env.REACT_APP_RECRUIT_MODULE_URL}/${props?.match?.params?.orgId}/boarding-document/:preBoardingId`
            } else if (checkCookie('ubs_token') && ["/:orgId/login"]?.includes(props?.match?.path) && props?.match?.params?.orgId) {
                /** Do not Remove this For Working old Email URL - redirection, Code adding date 23-12-2024, You can Remove after - 6 month of date */
                window.location.href = `${process.env.REACT_APP_RECRUIT_MODULE_URL}/${props?.match?.params?.orgId}/boarding-document/:preBoardingId`
            } else if (checkCookie('ubs_token') && !props?.match?.params?.orgId && ['/multi-factor-authenticate', '/setup-multi-factor', '/recovery-code', '/forget-with-recovery']?.includes(props?.match?.path)) {
                return (<Component {...props} />)
            } else if (checkCookie('ubs_token') && !["/:orgId/register"]?.includes(props?.match?.path)) {
                /** OnboardingUser will not Redirected to workspace */
                return (<Redirect to={_AFTRP ? '/change-password' : '/workspace'}/>)
            } else if (checkCookie('ubs_token') && ["/:orgId/register"]?.includes(props?.match?.path) && props?.match?.params?.orgId) {
                /** Redirect TO HRMS Module for onboarding*/
                window.location.href = `${process.env.REACT_APP_HRMS_MODULE_URL}/${props?.match?.params?.orgId}/employee-onboarding/employee-preview/:onboardingId`
            } else {
                return (<Component {...props} />)
            }
        }}/>
    );
};

export default PublicRoute;